// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cgv-page {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  width: 100%;
  padding: 2rem;
  margin: 0 !important;
}

.cgv-title-h1 {
  color: #ffa500;
}

.cgv-title-h2 {
  color: #ffa500;
}

.cgv-title-h3 {
  color: #ffa500;
}

.cgv-custom-container {
  max-width: inherit !important;
  margin: 0 !important;
}

.cgv-custom-paragraph {
  margin-bottom: 1em;
}

.cgv-custom-ul {
  list-style-type: decimal;
  margin-left: 20px;
}

.cgv-custom-title-h1 {
  color: #ffa500;
}

.cgv-custom-title-h2 {
  color: #ffa500;
}

.cgv-custom-title-h3 {
  color: #ffa500;
}

.mentions-container {
  width: 100%;
  padding: 2rem;
}

.mentions-container h1 {
  margin-bottom: 3rem;
}

.mentions-content {
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  background: #fffdfc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  height: 100%;
}

/* .mentions-content.fullpage {
  height: calc(
    100vh - 240px
  );
} 
*/

.mentions-body {
  padding: 0;
  height: 100%;
}

.mentions-iframe {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Mentions/Mentions.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;;CAKC;;AAED;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".cgv-page {\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  width: 100%;\n  padding: 2rem;\n  margin: 0 !important;\n}\n\n.cgv-title-h1 {\n  color: #ffa500;\n}\n\n.cgv-title-h2 {\n  color: #ffa500;\n}\n\n.cgv-title-h3 {\n  color: #ffa500;\n}\n\n.cgv-custom-container {\n  max-width: inherit !important;\n  margin: 0 !important;\n}\n\n.cgv-custom-paragraph {\n  margin-bottom: 1em;\n}\n\n.cgv-custom-ul {\n  list-style-type: decimal;\n  margin-left: 20px;\n}\n\n.cgv-custom-title-h1 {\n  color: #ffa500;\n}\n\n.cgv-custom-title-h2 {\n  color: #ffa500;\n}\n\n.cgv-custom-title-h3 {\n  color: #ffa500;\n}\n\n.mentions-container {\n  width: 100%;\n  padding: 2rem;\n}\n\n.mentions-container h1 {\n  margin-bottom: 3rem;\n}\n\n.mentions-content {\n  display: flex;\n  flex-direction: column;\n  margin-top: 2rem;\n  background: #fffdfc;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  height: 100%;\n}\n\n/* .mentions-content.fullpage {\n  height: calc(\n    100vh - 240px\n  );\n} \n*/\n\n.mentions-body {\n  padding: 0;\n  height: 100%;\n}\n\n.mentions-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
